import axios from "axios";
import {
    Pixel as SSPixel,
    Event as SSEvent,
    Category as SSCategory,
    Segment as SSSegment,
} from '@/components/SegmentSources'
import {LoadEvents} from "@/components/LoadEvents";

type SegmentSourcesRelative = {
    id: string
    name: string
    category: boolean
}

type SegmentSourcesEvent = {
    id: string
    site_name: string
}

type SegmentSourcesBricks = {
    events: Array<SegmentSourcesEvent>
    relatives: Array<SegmentSourcesRelative>
}

export function LoadSegmentSources(callback: any) {
    axios
        .get<SegmentSourcesBricks>('/api/v1/segments/sources')
        .then(response => {
            let pixels = [] as Array<SSPixel>
            let events = [] as Array<SSEvent>
            let categories = [] as Array<SSCategory>
            let segments = [] as Array<SSSegment>
            // if (response.data.events) {
            //     response.data.events.forEach(function (event: SegmentSourcesEvent) {
            //         if (!event.site_name) {
            //             return
            //         }
            //         pixels.push({
            //             id: event.id,
            //             name: event.site_name ? 'site: ' + event.site_name : event.id
            //         })
            //         events.push({
            //             id: event.id,
            //             name: event.site_name ? 'site: ' + event.site_name : event.id
            //         })
            //     })
            // }
            if (response.data.relatives) {
                response.data.relatives.forEach(function (relative: SegmentSourcesRelative) {
                    if (relative.category) {
                        categories.push({
                            id: relative.id,
                            name: relative.name,
                        })
                    } else {
                        segments.push({
                            id: relative.id,
                            name: relative.name,
                        })
                    }
                })
            }
            LoadEvents((es:any)=>{
                es.forEach((e:any) => {
                    pixels.push({
                        id: e.id,
                        name: e.name,
                    })
                    events.push({
                        id: e.id,
                        name: e.name,
                    })
                })
                callback({
                    pixels: pixels,
                    categories: categories,
                    segments: segments,
                    events: events,
                })
            })
        })
}